import React, { useState, useEffect } from "react";
import Sidebar from "../../../components/AdminComponents/SideNav";

import { SettingsMenu } from "../../../components/AdminComponents/MenuItems";

import { Spin } from "antd";
import { Table, Switch, Button, Divider, Tooltip } from "antd";

import Axios from "../../../api/Axios";
import { message } from "antd";

import { setMainAccessData } from "../../../store/slices/mainAccessData";
import { useDispatch } from "react-redux";
import { remainingViewportHeight } from "../../../components/icons/ApplicationColor";
import { useSelector } from "react-redux";
import { getUpdateStatus2 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import AccessFilterModal from "./Modals/AccessFilterModal";
import { env } from "../../../config";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
const MainAccess = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState();
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus2(userInfo, 2, 0);
  const [messageApi, contextHolder] = message.useMessage();
  //console.log(dataSource);
  const [loading, setLoading] = useState(false);
  const [profileID, setProfileID] = useState();
  const [visible, setVisible] = useState(false);
  const [applicationData, setApplicationData] = useState();
  const [selectedApps, setSelectedApps] = useState([]);
  const [approles, setAppRoles] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);

  // eslint-disable-next-line no-unused-vars

  useEffect(() => {
    setProfileID(dataSource?.[0].top_menu?.[0].sub_menu?.[0].id);
  }, [dataSource]);
  const fetchData = async (filter) => {
    setLoading(true);
    // console.log("Fetching Data")
    // console.log(selectedApps, selectedRoles)
    try {
      let url = `/globaluseraccess/`;
      if (filter === true) {
        url += `?application=${selectedApps.toString()}`;
        if (selectedRoles.length > 0) {
          url += `&role=${selectedRoles.toString()}`;
        }
      } else {
        setSelectedApps([]);
      }
      const response = await Axios.get(url);
      const data2 = response.data;

      dispatch(setMainAccessData(response.data));
      // Creating the desired data array
      const data = [];

      // Create objects based on side_menu and top_menu items
      data2.forEach((item) => {
        item.side_menu.forEach((sideMenu, index) => {
          sideMenu.top_menu.forEach((topMenu, topIndex) => {
            data.push({
              id: `${item.id}_${index}_${topIndex}`,
              name: topIndex === 0 ? item.name : " ",
              top_menu: [topMenu],
            });
          });
        });
      });

      setDataSource(data);
      setAccessData(
        data?.flatMap((item) =>
          item.top_menu.flatMap((menu) =>
            menu.sub_menu.flatMap((subMenu) => subMenu.role_access)
          )
        )
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
    setVisible(false);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [accessData, setAccessData] = useState();
  const UpdateSuccessfull = () => {
    fetchData();
    messageApi.open({
      type: "success",
      content: "Updated successfully.",
      duration: 5,
    });
  };

  const UpdateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Details have not been updated.",
      duration: 5,
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleSwitchChangeEdit = async (accessId, field) => {
    try {
      const updatedAccessData = accessData?.map((access) => {
        if (access.id === accessId) {
          return {
            ...access,
            [field]: !access[field],
          };
        }
        //console.log(access);
        return access;
      });

      setAccessData(updatedAccessData);
      //console.log(accessId, field);

      const payload = {
        view: updatedAccessData.find((access) => access.id === accessId)?.view,
      };

      await Axios.put(`/roleaccess/${parseInt(accessId)}/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      UpdateSuccessfull();
    } catch (err) {
      //console.log(err);
      UpdateFailed();
    }
  };
  const handleSwitchChangeUpdate = async (accessId, field) => {
    try {
      const updatedAccessData = accessData?.map((access) => {
        if (access.id === accessId) {
          return {
            ...access,
            [field]: !access[field],
          };
        }
        //console.log(access);
        return access;
      });

      setAccessData(updatedAccessData);
      //console.log(accessId, field);

      const payload = {
        update: updatedAccessData.find((access) => access.id === accessId)
          ?.update,
      };

      await Axios.put(`/roleaccess/${parseInt(accessId)}/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      UpdateSuccessfull();
    } catch (err) {
      UpdateFailed();
    }
  };

  const topMenu = dataSource?.[0]?.top_menu;
  const roles = [
    ...new Set(
      topMenu?.flatMap((menu) =>
        menu.sub_menu.flatMap((subMenu) =>
          subMenu.role_access.map((access) => access.role)
        )
      )
    ),
  ];

  const columns = [
    {
      title: "Left Menu",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 150,
      render: (text) => <div>{text}</div>,
    },
    {
      title: "Top Menu",
      dataIndex: "top_menu",
      fixed: "left",
      width: 180,
      render: (_, record) => {
        const menuData = record.top_menu;
        return (
          <div>
            {menuData.map((menu) => (
              <div key={menu.id}>{menu.name}</div>
            ))}
          </div>
        );
      },
    },
    {
      title: "Sub Menu",
      dataIndex: "top_menu",
      fixed: "left",
      width: 250,
      render: (_, record) => {
        const menuData = record.top_menu;
        const menuElements = menuData.flatMap((menu, menuIndex) =>
          menu.sub_menu.map((subMenu, subMenuIndex) => (
            <React.Fragment key={subMenu.id}>
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  height: "24px",
                }}
              >
                {subMenu.name}
              </div>
              {(subMenuIndex !== menu.sub_menu.length - 1 ||
                menuIndex !== menuData.length - 1) && (
                <Divider style={{ margin: "4px 0", borderWidth: "2px" }} />
              )}
            </React.Fragment>
          ))
        );

        return <div>{menuElements}</div>;
      },
    },
    ...roles.flatMap((role) => [
      {
        title: role,
        width: 150,
        children: [
          {
            title: "View",
            width: 60,
            render: (_, record) => {
              const switches = record.top_menu.flatMap((menu, menuIndex) =>
                menu.sub_menu.flatMap((subMenu, subMenuIndex) =>
                  subMenu.role_access
                    .filter((access) => access.role === role)
                    .map((access) => (
                      <React.Fragment key={access.id}>
                        <div
                          style={{
                            height: "24px",
                          }}
                        >
                          <Tooltip
                            title={
                              subMenu.id === profileID ||
                              !updateAuth ||
                              !accessData?.find((data) => data.id === access.id)
                                ?.editable
                                ? "Edit Not Allowed"
                                : "Click to Change"
                            }
                            color={
                              subMenu.id === profileID ||
                              !updateAuth ||
                              !accessData?.find((data) => data.id === access.id)
                                ?.editable
                                ? "#f50"
                                : "#87d068"
                            }
                            trigger="hover"
                          >
                            <Switch
                              disabled={
                                subMenu.id === profileID ||
                                !updateAuth ||
                                !accessData?.find(
                                  (data) => data.id === access.id
                                )?.editable
                              }
                              checked={
                                accessData?.find(
                                  (data) => data.id === access.id
                                )?.view
                              }
                              onChange={() =>
                                handleSwitchChangeEdit(access.id, "view")
                              }
                              size="small"
                            />
                          </Tooltip>
                        </div>
                        {(subMenuIndex !== menu.sub_menu.length - 1 ||
                          menuIndex !== record.top_menu.length - 1) && (
                          <Divider
                            style={{ margin: "4px 0", borderWidth: "2px" }}
                          />
                        )}
                      </React.Fragment>
                    ))
                )
              );
              return <div>{switches}</div>;
            },
          },
          {
            title: "Update",
            width: 80,
            render: (_, record) => {
              const switches = record.top_menu.flatMap((menu, menuIndex) =>
                menu.sub_menu.flatMap((subMenu, subMenuIndex) =>
                  subMenu.role_access
                    .filter((access) => access.role === role)
                    .map((access) => (
                      <React.Fragment key={access.id}>
                        <div
                          style={{
                            height: "24px",
                          }}
                        >
                          <Tooltip
                            title={
                              !updateAuth ||
                              !accessData?.find((data) => data.id === access.id)
                                ?.editable
                                ? "Edit Not Allowed"
                                : "Click to Change"
                            }
                            color={
                              !updateAuth ||
                              !accessData?.find((data) => data.id === access.id)
                                ?.editable
                                ? "#f50"
                                : "#87d068"
                            }
                            trigger="hover"
                          >
                            <Switch
                              disabled={
                                !updateAuth ||
                                !accessData?.find(
                                  (data) => data.id === access.id
                                )?.editable
                              }
                              checked={
                                accessData?.find(
                                  (data) => data.id === access.id
                                )?.update
                              }
                              onChange={() =>
                                handleSwitchChangeUpdate(access.id, "update")
                              }
                              size="small"
                            />
                          </Tooltip>
                        </div>
                        {(subMenuIndex !== menu.sub_menu.length - 1 ||
                          menuIndex !== record.top_menu.length - 1) && (
                          <Divider
                            style={{ margin: "4px 0", borderWidth: "2px" }}
                          />
                        )}
                      </React.Fragment>
                    ))
                )
              );
              return <div>{switches}</div>;
            },
          },
        ],
      },
    ]),
  ];

  async function getData() {
    await Axios.get("/applicationlist/?status=True").then((res) => {
      setApplicationData(res.data);
    });
  }
  async function getRoleData(selectedData, clear) {
    let filterData = null;
    if (clear) {
      filterData = "";
    } else {
      if (selectedData) {
        filterData = [selectedData, ...selectedApps];
      } else {
        filterData = selectedApps;
      }
    }
    await Axios.get(
      `applicationrole/?application=${filterData.toString()}`
    ).then((res) => {
      setAppRoles(res.data);
    });
  }
  async function handleApply() {
    fetchData(true);
  }
  function HandleAppSelect(selected) {
    setSelectedApps([selected, ...selectedApps]);
    getRoleData(selected);
  }

  function handleCancel() {
    setSelectedApps([]);
    fetchData(false);
    getRoleData();
  }
  function handleReset() {
    fetchData(false);
    setSelectedApps([]);
    setSelectedRoles([]);
  }
  function HandleRemoveSelect(deselected) {
    // const new_selected = selectedApps.splice(deselected)
    setSelectedApps((state) => state.filter((item) => item !== deselected));
    setAppRoles([]);
  }

  function handleRoleSelect(role) {
    console.log(role);
    setSelectedRoles([role, ...selectedRoles]);
  }
  function handleRemoveRole(deselected) {
    console.log(deselected);
    setSelectedRoles((state) => state.filter((item) => item !== deselected));
  }
  useEffect(() => {
    if (env !== "prod") {
      getData();
    }
  }, []);
  const showModal = () => {
    setVisible(true);
  };
  return (
    <div>
      <Sidebar props={SettingsMenu}>
        {contextHolder}
        <Spin spinning={loading}>
          <CommonTopDetails
            title="Menu Listing"
            titleSuffix={`${2} menu(s)`}
            searchPlaceholder="Search by..."
            showSearch={false}
            showAddButton={false}
            filterAction={env !== "prod"}
            filterUrl={false}
            filterButtonProps={{
              modalType: "PopUP",
              modalProps: showModal,
            }}
            resetButtonProps={{
              modalProps: handleReset,
            }}
            customContent={
              updateAuth && (
                <Button
                  type="primary"
                  onClick={() => {
                    //to be developed
                  }}
                  disabled
                  // className="setting-add"
                >
                  EDIT DETAILS
                </Button>
              )
            }
          />

          <div style={{ overflowX: "auto" }}>
            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              bordered
              size="small"
              rowKey="id"
              scroll={{
                x: 1000,
                y: `${remainingViewportHeight(30)}px`,
              }}
              className="table-container-2"
              style={{ margin: "1rem" }}
            />
          </div>
          <></>
        </Spin>
        {env !== "prod" ? (
          <AccessFilterModal
            visible={visible}
            closemodal={() => {
              setVisible(false);
            }}
            applications={applicationData}
            setSelectedApps={setSelectedApps}
            selectedApps={selectedApps}
            handleApply={handleApply}
            HandleAppSelect={HandleAppSelect}
            handleCancel={handleCancel}
            handleReset={handleReset}
            HandleRemoveSelect={HandleRemoveSelect}
            Approles={approles}
            handleRoleSelect={handleRoleSelect}
            handleRemoveRole={handleRemoveRole}
            selectedRoles={selectedRoles}
          />
        ) : (
          ""
        )}
      </Sidebar>
    </div>
  );
};

export default MainAccess;
